import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAllTestimonials,
  insertTestimonial,
  editTestimonial,
  deleteTestimonial,
} from "./TestimonialThunks";

const TestimonialSlice = createSlice({
  name: "testimonials",
  initialState: {
    fetchTestimonialPending: false,
    testimonialList: null,
    pagination: null,
    fetchTestimonialRejected: null,

    status: "idle",
    error: null,
  },
  extraReducers: (builder) => {
    builder
      // Fetch all testimonials
      .addCase(fetchAllTestimonials.pending, (state) => {
        state.fetchTestimonialPending = true;
        state.fetchTestimonialRejected = null;
      })
      .addCase(fetchAllTestimonials.fulfilled, (state, action) => {
        state.fetchTestimonialPending = false;
        if (action.payload?.pagination?.page==1) {

          state.testimonialList = action.payload.data;
        state.pagination = action.payload.pagination;

        }else
        {
          action.payload.data.forEach((item) => {
            if (!state.testimonialList.some(existingItem => existingItem._id === item._id)) {
              state.testimonialList.push(item);
            }
          });
        }
        state.pagination = action.payload.pagination;

      })
      .addCase(fetchAllTestimonials.rejected, (state, action) => {
        state.fetchTestimonialPending = false;
        state.fetchTestimonialRejected = action.payload;
      })

  },
});

export const {

} = TestimonialSlice.actions;

export default TestimonialSlice.reducer;
